import React = require('react');
import { Tooltip } from '@tableau/widgets';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { tooltipStyle } from './ExtensionsSectionStyle';

export interface TooltipProps {
  testId: string;
  content: string;
}

export function QuickTooltip(props: TooltipProps) {
  // when tooltip plumbs through testId, delete this comment and data-tb-test-id applied to the img tag below
  return <Tooltip
    testId={props.testId}
    getContent={ () => {
      return <span>{props.content}</span>;
    }}>
    <img data-tb-test-id={props.testId} className={tooltipStyle} src={imgPath('info_14px_small.svg')} alt={'tooltip info icon'}/>
  </Tooltip>;
}
